<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="valid-user-view">
    <div class="valid-wrap">
      <div class="valid-head">
        <div class="icon-ajuntament" />
      </div>
      <h2>{{ $t('valid_title') }}</h2>
      <p class="valid-desc">{{ $t('valid_desc') }}</p>
      <div class="bottom-wrapper">
        <div class="button-wrap" @click="routeChange('Login')">
          <span>{{ $t('login') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      emailInput: '',
    }
  },
  computed: {},
  watch: {},
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
  },
}
</script>

<style lang="stylus" scoped>
.valid-user-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: rgba($bcn-dark-blue-gray, 0.05)

  .valid-wrap
    display: flex
    flex-direction: column
    align-items: center
    padding: vw(20px)
    min-width: 250px
    width: 60%
    border-radius: 8px
    background-color: #fff
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    gap: vw(5px)

    .bottom-wrapper
      margin-top: vw(20px)
      width: 50%

      span
        m-font-size(12, 20)
        margin-right: vw(4px)

      .button-wrap
        display: flex
        justify-content: center
        margin: vw(5px) 0
        padding: vw(8px) 0
        border-radius: 4px
        background-color: black
        cursor: pointer

        span
          color: white
          m-font-size(14, 20)

    .valid-head
      display: flex
      justify-content: space-between
      width: 100%

      .icon-ajuntament
        width: vw(176px)
        height: vw(45px)
        background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
        background-position: center center
        background-size: cover
        background-repeat: no-repeat

    h2
      margin-block-start: 1.5em
      font-size(32, 44)
      font-weight: 600

    .valid-desc
      display: flex
      justify-content: center
      font-size(20, 24)
      margin-bottom: vw(20px)
      width: 85%
      font-weight: 400
</style>